'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EducatorInfo;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Links = require('shared/components/Links');

var _ProgramTypes = require('shared/components/ProgramTypes');

var _renderTitle = require('shared/modules/utils/renderTitle');

var _renderTitle2 = _interopRequireDefault(_renderTitle);

var _HorizontalRule = require('../HorizontalRule');

var _HorizontalRule2 = _interopRequireDefault(_HorizontalRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EducatorInfo(_ref) {
  var moduleClass = _ref.moduleClass,
      programs = _ref.programs,
      program_types = _ref.program_types;

  return _react2.default.createElement(
    'div',
    {
      className: 'type-educator_info ' + moduleClass
    },
    _react2.default.createElement(
      'div',
      { className: 'cf' },
      _react2.default.createElement(
        'div',
        { className: 'type-half_width programs' },
        (0, _renderTitle2.default)('Program Types'),
        _react2.default.createElement(_ProgramTypes.ProgramTypes, {
          programTypes: program_types
        })
      )
    ),
    _react2.default.createElement(_HorizontalRule2.default, { moduleClass: '', addClass: 'module' }),
    _react2.default.createElement(
      'div',
      { className: 'programs type-half_width' },
      (0, _renderTitle2.default)('Financial Services Programs'),
      _react2.default.createElement(_Links.Links, { links: programs })
    )
  );
} /*
    {
      "type": "educator_info",
      "programs": [
        {
          "href": "#",
          "label": "Auditing Technology"
        },
        {
          "href": "#",
          "label": "Financial Management"
        }
      ],
      "program_types": [
        "certificate",
        "associate"
      ]
    }
  
    This module is specific to the Educator template.
    It has a list of programs, specified under the programs
    attribute, which is an array of objects each containing a
    href and a label.
  
    There is also an attribute program_types which should
    contain only the relevant program types for an educator:
  
    "program_types": [
      "certificate",
      "associate"
    ]
  
    Program types not associated with an educator should not be included.
   */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/EducatorInfo/EducatorInfo.jsx
// module id = 1153
// module chunks = 0